export class Page {
  public id: string;
  public pageId: number;
  public pageStatus: string;
  public name: string;
  public detail: string;
  public url: string;
  public createdDate: Date;
  public updatedDate: Date;
  public isActive: boolean;
  public metaTitle: string;
  public metaKeyword: string;
  public metaDescription: string;
}




// WEBPACK FOOTER //
// ./src/app/models/static-page/page-model.ts